import { Component, OnInit ,ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-competencia',
  templateUrl: './competencia.component.html',
  styleUrls: ['./competencia.component.scss']
})
export class CompetenciaComponent implements OnInit {

  @ViewChild('ccomp',null) ccomp;
  constructor(public authService: AuthService,
    public router: Router,
    private route: ActivatedRoute
    ) { }
  caller;
  callerant;

  ngOnInit() {
    this.route.queryParams.subscribe(params => { this.caller = params.caller;  this.callerant = params.callerant;});   
    this.ls_competencia();
    this.ls_grupo_c();
 
  }
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  gpo_=[{gpo:"",id:0}];
  
  vcatalog_(){
    this.bndokcatl=true;
    this.bndCatalog=false;
    this.tpoacper=true;
  }
  gda_catalog_(){
    console.log("sgrpu: "+this.sgroup)
    if(this.sgroup==undefined || this.sgroup=="")return "";
    let postData = {       
      id_cliente:localStorage.getItem("id_cliente"),
      competencia:"-",
      grupo:this.sgroup
    } 
    console.log(postData);
    this.authService.service("/api/gda_comp_catalog2",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                     
          this.ls_competencia();
          this.can_catalog_();
          this.ls_grupo_c();
          this.loading=true;
          try { 
            var postdata={
                id:res[1][0].id_comp,
                id_gpo_competencia:res[0][0].id_gpo,
                competencia:"-"
              }
            //console.log(postData);
            this.edt_comp(postdata);            
            this.loading=false;
          } catch (error) {            
            console.log("erro")
            this.loading=false;
          }
          this.loading=false;
        },
        error => {
          this.loading=false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! _del_comp', '', 'error');
        });   

  }
  public loading:boolean=false;
  fn_ncomp(){
    this.sgroup="";
    this.selgpoComp="";
    this.scompentence="";
    this.bndCatalog=true;
    this.bndokcatl=false;
  }
  bndokcatl:boolean=false;
  edt_comp(itm){
    this.id_competencia=itm.id;
    this.bndCatalog=true;
    this.bndokcatl=false;
    this.selgpoComp=itm.id_gpo_competencia;
    this.scompentence=itm.competencia;
    this.tpoacper=false;
  }
  _del_comp(itm){
    if(confirm("Confirm to delete this row?")==false)return
    let postData = {       
      id:itm.id
    } 
    console.log(postData);
    this.authService.service("/api/del_comp",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_competencia();
          swal.fire('¡ok', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! _del_comp', '', 'error');
        });   

  }
  del_comp(){
    this.tpoacper=false;
  }
  sgroup;
  selgpoComp;
  scompentence;
  tpoacper:boolean=true;
  bndCatalog:boolean=true;
  competencia:any;
  gdacomp(){ 
    let postData = { 
      competencia:this.scompentence,
      grupo:this.sgroup,
      selgrupo:Number(this.selgpoComp),
      id_cliente:localStorage.getItem("id_cliente"),
    } 
    console.log("gda");
    console.log(postData);
    this.authService.service("/api/gdacomp",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._competencia=res;
          this.ls_competencia();
          this.ccomp.nativeElement.click();
          swal.fire('¡ok', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   
  }
  id_competencia:number=0;
  updcomp(){
    let postData = { 
      id:this.id_competencia,
      competencia:this.scompentence,
      grupo:this.sgroup,
      selgrupo:this.selgpoComp,
      id_cliente:localStorage.getItem("id_cliente"),
    } 
    console.log(postData);
    this.authService.service("/api/updcomp",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          swal.fire('¡ok', '', 'success');
          this.ccomp.nativeElement.click();
          this.ls_competencia();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! gdareportto', '', 'error');
        }); 

  }
  _competencia:any;
  id_cliente:number=0;
  ls_grupo(){
    this.gpo_=[];
    console.log(this._competencia.length);
    for(var i=0;i<this._competencia.length;i++){
      if(i==0){
        this.gpo_.push({
          gpo:this._competencia[i].grupo,
          id:this._competencia[i].id_gpo_competencia})
      }else{
        var bndc=0;
        for(var j=0;j<this.gpo_.length;j++){
          if(this.gpo_[j].id==this._competencia[i].id_gpo_competencia){
            bndc=1;
          }          
        }
        if(bndc==0){
          this.gpo_.push({
            gpo:this._competencia[i].grupo,
            id:this._competencia[i].id_gpo_competencia})
        }
      }
    }
    console.log(this.gpo_);    
  }
  can_catalog_(){
    this.bndokcatl=false;
    this.bndCatalog=true;
  }
  ls_competencia(){    
    let postData = { 
      id_cliente:localStorage.getItem("id_cliente"),
    } 
    console.log(postData);
    this.authService.service("/api/get_competencia_cliente",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._competencia=res;
          this.ls_grupo();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   
    
  }
  grupo;
  ls_grupo_c(){   
    console.log("ls_grupo_c") 
    let postData = { 
      id_cliente:localStorage.getItem("id_cliente"),
    } 
    console.log(postData);
    this.authService.service("/api/get_grupo_catalog",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          console.log(res);
          console.log("-----");
          this.grupo=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! get_grupo_catalog', '', 'error');
        });   
    
  }

  _go(){      
    //this.router.navigate([this.caller]);

    this.router.navigate(
      [this.caller],
      { queryParams: { caller: this.callerant} }
    );

  }

}
